<template>
  <div class="tag-list">
    <Action-panel :isReady="isPageReady">
      <Button-base
        :type="2"
        :text="translations.labels.button_add_tag"
        :hoverInfo="translations.labels.button_add_tag_hover"
        :onClick="newItem"
      />
    </Action-panel>

    <TableList
      :is-ready="isPageReady"
      :headers="headers"
      :items="model"
      :items-per-page="-1"
      sortable
      hideFooter
      @sorted="saveOrder"
      />
  </div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
import Container from "@/components/dom/Container";
import ActionPanel from "@/components/panel/ActionPanel";
import InnerPanel from "@/components/panel/InnerPanel";
import TablePanel from "@/components/panel/TablePanel";
import ButtonBase from "@/components/dom/ButtonBase";
import SvgIcon from "@/components/dom/SvgIcon";
import Round from "@/components/dom/Round";
import TableList from "@/components/table/TableList";

@Component({
  components: {
    ActionPanel,
    InnerPanel,
    TablePanel,
    ButtonBase,
    SvgIcon,
    Round,
    Container,
    TableList,
  },
  inject: {
    tagService: "tagService",
    toastService: "toastService",
  },
})
export default class TagList extends Vue {
  isPageReady = false;
  model = [];
  search = "";
  idTaxonomy = null;

  async init() {
    try {
      this.idTaxonomy = this.$route.params.idTaxonomy;
      this.model = await this.tagService.list({ idTaxonomy: this.idTaxonomy });
      this.isPageReady = true;
    } catch (error) {
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }

  toastSuccessLabel(isEnabled) {
    isEnabled
      ? this.toastService.success(this.translations.success.tag_disable)
      : this.toastService.success(this.translations.success.tag_enable);
  }

  async swapEnabled(idTag, isEnabled) {
    const status = isEnabled ? "disable" : "enable";
    try {
      await this.tagService.setEnabling(idTag, status);
      this.model = await this.tagService.list({ idTaxonomy: this.idTaxonomy });
      this.toastSuccessLabel(isEnabled);
    } catch (error) {
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }

  newItem() {
    this.$router.push(`/taxonomy/${this.idTaxonomy}/tag/new`);
  }

  get translations() {
    return this.$store.state.translationsStore.currentLang;
  }

  get headers() {
    return [
      {
        text: this.translations.labels.tag_form_code,
        value: "code",
      },
      {
        text: this.translations.labels.table_order,
        value: "displayOrder"
      },
      {
        text: this.translations.labels.table_detail,
        value: "detail",
        type: "link",
        icon: "mdi-feature-search-outline",
        formatValue: (item) => {
          return `/taxonomy/${this.idTaxonomy}/tag/detail/${item.id}`;
        },
      },
      {
        text: this.translations.labels.table_edit,
        value: "edit",
        type: "link",
        formatValue: (item) => {
          return `/taxonomy/${this.idTaxonomy}/tag/edit/${item.id}`;
        },
        icon: "mdi-pencil",
        buttonType: 2,
      },
      {
        text: this.translations.labels.table_enable,
        value: "isEnabled",
        type: "switch",
        itemValue: (item) => {
          return item.isEnabled;
        },
        onAction: (item) => {
          this.swapEnabled(item.id, item.isEnabled);
        },
      },
    ];
  }

  async saveOrder(event) {
    const movedItem = this.model.splice(event.oldIndex, 1);
    this.model.splice(event.newIndex, 0, movedItem[0]);

    let newOrders = [];
    this.model.forEach((m, i) => {
      const index = i + 1;
      this.model[i].priorityOrder = index;
      newOrders.push({
        id: m.id,
        displayOrder: index
      });
    });

    try {
      await this.tagService.saveOrder(newOrders);
    } catch (e) {
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }

  mounted() {
    this.init();
    this.$store.commit(
      "SET_SECTION_TITLE",
      this.translations.pageTitles.tags_list
    );
  }
}
</script>